import React, { useRef } from "react";
import { Box, Grid, Typography } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { blue, grey } from "@mui/material/colors";
import { useDrag } from "react-dnd";
import { DND_ITEM_TYPES } from "../supplyTableRow";
import IntersectionObservedView from "../../../../../components/IntersectionObservedView";

const ROW_HEIGHT = 36;

const getRowBgColor = (selected, added) => {
  if (selected) return blue[100];
  if (added) return grey[200];
  return "transparent";
};

const getRowHoverBgColor = (selected, added) => {
  if (selected) return blue[200];
  if (added) return grey[300];
  return blue[50];
};

const AddProductSidebarRow = ({ data, part, selected, onSelect, onDragBegin, onDragCancel }) => {
  const rowRef = useRef(null);
  const isAdded = !!data.added;

  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: DND_ITEM_TYPES.ADD_PRODUCT_ROW,
      item: () => {
        onDragBegin?.();
        return {
          type: DND_ITEM_TYPES.ADD_PRODUCT_ROW,
          ...data,
          part,
        };
      },
      end: () => {
        onDragCancel?.();
      },
      canDrag: () => !isAdded,
      collect: (monitor) => ({ isDragging: monitor.isDragging() }),
    }),
    [data, part, isAdded, onDragBegin, onDragCancel]
  );

  // drag ref を常に描画される外側の div に適用（IntersectionObservedView 内だと遅延する）
  drag(rowRef);

  return (
    <div
      ref={rowRef}
      style={{
        height: ROW_HEIGHT,
        borderBottom: "1px solid rgba(0,0,0,0.12)",
        opacity: isDragging ? 0.4 : 1,
        cursor: isAdded ? "default" : "grab",
      }}
    >
    <IntersectionObservedView rootMargin="50px">
      <Box
        onClick={() => !isAdded && onSelect?.(data)}
        sx={{
          height: ROW_HEIGHT,
          bgcolor: getRowBgColor(selected, isAdded),
          transition: "background-color 0.15s ease",
          "&:hover": {
            bgcolor: isAdded ? grey[300] : getRowHoverBgColor(selected, isAdded),
          },
        }}
      >
        <Grid
          container
          alignItems="center"
          spacing={0.5}
          sx={{ height: "100%", px: 0.5 }}
        >
          {/* Drag icon */}
          <Grid item xs={0.6} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <DragIndicatorIcon sx={{ fontSize: 16, color: "grey.400", opacity: isAdded ? 0.3 : 1 }} />
          </Grid>

          {/* 商品名 */}
          <Grid item xs={3.5}>
            <Typography variant="body2" noWrap title={data.productName} sx={{ fontSize: 13 }}>
              {data.productName}
            </Typography>
          </Grid>

          {/* 産地 */}
          <Grid item xs={2.5}>
            <Typography variant="body2" noWrap title={data.origin} sx={{ fontSize: 13 }}>
              {data.origin}
            </Typography>
          </Grid>

          {/* 規格 */}
          <Grid item xs={3}>
            <Typography variant="body2" noWrap title={data.displaySize} sx={{ fontSize: 13 }}>
              {data.displaySize}
            </Typography>
          </Grid>

          {/* 発注単位 */}
          <Grid item xs={2.4}>
            <Typography variant="body2" noWrap sx={{ fontSize: 13 }}>
              {data.orderingUnit}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </IntersectionObservedView>
    </div>
  );
};

export default AddProductSidebarRow;
